module.exports = __webpack_public_path__ + "media/images/Checkmark_gray-38e883e741538b8847464e41f2801ece.png";